import { useEffect, useState, useCallback } from 'react'
import { theme } from 'theme'

interface Resolution {
  mobile: boolean
  tablet: boolean
  desktop: boolean
  xs: boolean
  smx: boolean
  sm: boolean
  mdx: boolean
  md: boolean
  lg: boolean
  xl: boolean
  xxl: boolean
  xxxl: boolean
  apple: boolean
}

export const useResolution = (): Resolution => {
  const defaultResolution: Resolution = {
    mobile: window.innerWidth <= theme.breakpoint.sm,
    tablet: window.innerWidth > theme.breakpoint.sm && window.innerWidth <= theme.breakpoint.lg,
    desktop: window.innerWidth > theme.breakpoint.lg,
    xs: window.innerWidth <= theme.breakpoint.xs,
    smx: window.innerWidth <= theme.breakpoint.smx,
    sm: window.innerWidth <= theme.breakpoint.sm,
    mdx: window.innerWidth <= theme.breakpoint.mdx,
    md: window.innerWidth <= theme.breakpoint.md,
    lg: window.innerWidth <= theme.breakpoint.lg,
    xl: window.innerWidth <= theme.breakpoint.xl,
    xxl: window.innerWidth <= theme.breakpoint.xxl,
    xxxl: window.innerWidth <= theme.breakpoint.xxxl,
    apple: window.innerWidth <= theme.breakpoint.apple
  }
  const [resolution, setResolution] = useState<Resolution>(defaultResolution)

  const updateDimensions = useCallback(() => {
    setResolution({
      mobile: window.innerWidth <= theme.breakpoint.sm,
      tablet: window.innerWidth > theme.breakpoint.sm && window.innerWidth <= theme.breakpoint.lg,
      desktop: window.innerWidth > theme.breakpoint.lg,
      xs: window.innerWidth <= theme.breakpoint.xs,
      smx: window.innerWidth <= theme.breakpoint.smx,
      sm: window.innerWidth <= theme.breakpoint.sm,
      mdx: window.innerWidth <= theme.breakpoint.mdx,
      md: window.innerWidth <= theme.breakpoint.md,
      lg: window.innerWidth <= theme.breakpoint.lg,
      xl: window.innerWidth <= theme.breakpoint.xl,
      xxl: window.innerWidth <= theme.breakpoint.xxl,
      xxxl: window.innerWidth <= theme.breakpoint.xxxl,
      apple: window.innerWidth <= theme.breakpoint.apple
    })
  }, [])

  useEffect(() => {
    window.addEventListener('resize', updateDimensions)
    return () => {
      window.removeEventListener('resize', updateDimensions)
    }
  }, [updateDimensions])

  return resolution
}
